import * as h from "react";
const e = (l) => /* @__PURE__ */ h.createElement(
  "svg",
  {
    id: "amex-logo_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1940 897.95",
    ...l
  },
  /* @__PURE__ */ h.createElement("defs", null, /* @__PURE__ */ h.createElement("clipPath", { id: "amex-logo_svg__clippath" }, /* @__PURE__ */ h.createElement(
    "path",
    {
      className: "amex-logo_svg__cls-2",
      d: "M-23.99-50.44h1987.97v998.83H-23.99z"
    }
  )), /* @__PURE__ */ h.createElement("style", null, ".amex-logo_svg__cls-2{fill:#016fcf}.amex-logo_svg__cls-3{fill:#fff}")),
  /* @__PURE__ */ h.createElement(
    "path",
    {
      id: "amex-logo_svg__SVGID",
      className: "amex-logo_svg__cls-2",
      d: "M-23.99-50.44h1987.97v998.83H-23.99z"
    }
  ),
  /* @__PURE__ */ h.createElement(
    "path",
    {
      className: "amex-logo_svg__cls-2",
      d: "M-23.99-50.44h1987.97v998.83H-23.99z"
    }
  ),
  /* @__PURE__ */ h.createElement("g", { clipPath: "url(#amex-logo_svg__clippath)" }, /* @__PURE__ */ h.createElement(
    "path",
    {
      className: "amex-logo_svg__cls-2",
      d: "M-24.09-50.44v998.83h1988.08V-50.44H-24.09z"
    }
  )),
  /* @__PURE__ */ h.createElement(
    "path",
    {
      className: "amex-logo_svg__cls-3",
      d: "M1054.47 271.61h43.64v163.16h-43.64zM968.29 341.48h-45.72v-32.85h45.72c12.99 0 19.61 7.72 19.61 16.55-.12 9.07-6.62 16.3-19.61 16.3m63.37-17.28c0-31.26-22.43-52.71-58.23-52.71h-94.39v163.28h43.64v-57.12h15.81l49.52 57.12h54.06l-54.06-58.96c27.34-5.88 43.64-25.99 43.64-51.61M1164.79 354.6v-3.06c0-24.27 13.48-41.68 41.43-41.68h48.54v-38.25h-52.22c-53.81 0-81.39 34.45-81.39 79.92v3.31c0 50.63 31.26 79.92 79.31 79.92h14.95l17.53-37.02h-25.62c-26.23-.12-42.54-14.71-42.54-43.15M336.5 365.76l22.8-54.55 22.8 54.55h-45.6zm-4.66-94.14l-72.08 163.16h48.05l13.73-33.1h75.51l13.97 33.1h49.16L388.1 271.62h-56.27zM574.31 374.34l-37.38-102.73H468.4v163.16h42.91V317.21l43.15 117.56h38.73l43.03-117.56v117.56h42.9V271.61h-67.79l-37.02 102.73zM712.46 434.77h138.03v-37.14H756.1v-26.11h92.06V334.5H756.1v-25.87h94.39v-37.02H712.46v163.16zM1312.26 365.76l22.8-54.55 22.8 54.55h-45.6zm-4.66-94.14l-71.96 163.16h48.05l13.73-33.1h75.51l13.97 33.1h49.16l-72.08-163.16h-56.39zM1565.63 371.15l-66.44-99.54h-54.91v163.16h43.27V331.43l68.52 103.34h52.71V271.61h-43.15v99.54zM1422.21 544.48h-40.08c-8.58 0-14.95-5.15-14.95-12.99s6.25-12.87 14.95-12.87h72.45l17.04-37.02h-89.73c-37.02 0-58.23 21.94-58.23 51.24 0 30.77 20.47 48.67 52.47 48.67h40.08c8.83 0 14.95 5.15 14.95 12.99s-6.01 12.99-14.95 12.99h-87.4v37.02h87.65c36.65 0 58.23-21.45 58.23-52.96 0-29.66-19.12-47.07-52.47-47.07M1081.07 551.47h-45.72v-32.85h45.72c12.99 0 19.61 7.72 19.61 16.55s-6.62 16.3-19.61 16.3m63.37-17.28c0-31.26-22.43-52.71-58.23-52.71h-94.39v163.16h43.64v-57.12h15.81l49.65 57.12h54.06l-54.06-58.96c27.21-5.76 43.52-25.86 43.52-51.48M1167.24 644.63h138.03v-37.02h-94.39V581.5h92.06v-37.02h-92.06v-25.86h94.39v-37.15h-138.03v163.16zM909.7 554.41h-46.83v-35.92h46.83c12.99 0 19.61 8.21 19.61 18.14s-6.5 17.77-19.61 17.77m5.15-72.94h-95.61v163.16h43.64v-53.2h50.63c36.77 0 59.7-23.29 59.7-55.04-.12-32.48-22.43-54.92-58.35-54.92M1582.43 544.48h-40.08c-8.58 0-14.95-5.15-14.95-12.99s6.25-12.87 14.95-12.87h72.45l17.04-37.02h-89.73c-37.02 0-58.23 21.94-58.23 51.24 0 30.77 20.47 48.67 52.47 48.67h40.08c8.83 0 14.95 5.15 14.95 12.99s-6.01 12.99-14.95 12.99h-87.4v37.02h87.65c36.65 0 58.23-21.45 58.23-52.96 0-29.66-19.12-47.07-52.47-47.07M468.4 644.63h138.03v-37.02h-94.39V581.5h92.06v-37.02h-92.06v-25.86h94.39v-37.15H468.4v163.16zM811.39 481.47h-55.53l-42.42 49.16-42.41-49.16h-56.88l71.84 80.66-73.19 82.5h55.41l44.5-51.73 44.62 51.73h56.88l-73.68-83.36 70.86-79.8z"
    }
  )
);
export {
  e as default
};
